import router from '../router/index.js'
import axios from 'axios'
import store from '@/services/store'

const opts = {
  baseURL: store ? store.getters.serverEndpoint : '',
}

const instance = axios.create(opts)

instance.interceptors.request.use(config => {
    config.headers['User-Token'] = store.state.userData.token
    config.headers['work-area-address'] = store.state.userData.workAreaAddress
    config.headers['do-not-limit-work-area-address'] =
      store.state.userData.doNotLimitWorkAreaAddress
    if (!config.baseUrl) {
      config.baseURL = store ? store.getters.serverEndpoint : ''
    }
    if (!config.url.match(/^\/cloudfunctions$/)) {
      const ApiURL = process.env.API_URL
      || process.env.NODE_ENV === 'production' ?
        'https://api.dieselservice.com.ua:38443'
        : 'https://api.dieselservice.com.ua:38999'

      if (config.url == "prepareLongRequest") {
        config.baseURL = ApiURL + '/api/'
      } else {
        config.headers['original-url'] = config.baseURL
        if (store.state || !store.state.APIAddress) {
          config.baseURL = ApiURL + '/workshop/'
        } else {
          config.baseURL = store.state.APIAddress
        }
      }
    }

    return config
  }
)

instance.interceptors.response.use(
  response => {
    if (response.data && response.data.status) {
      const dataStatus = parseInt(response.data.status)
      //статусы до 24000 - ошибки, при кототрых логика исполнения должна прерываться
      //Не найден сотрудник, пометка на удаление, просрочен токен, коды свыше 24000 -
      //предназначены для переключения условных веток обработки, например, если нельза стартовать работу
      //по причине того, что активна другая работа
      if (dataStatus !== 0 && dataStatus < 24000) {
        response.data.dataStatus = dataStatus
        processApiError(response.data)
        return Promise.reject()
      }
    }
    return response
  },
  error => {
    console.error(error)
    return Promise.reject(error)
    // debugger
    try {
      if (error.response.config.url === '/InitApp') {
        processApiError('Для поддержки новых функций обновите базу данных 1С!')
        return Promise.reject(error)
      }

      if (error.response && error.response.status === 401) {
        processApiError(error)
      } else if (error.response && error.response.data) {
        processApiError(error.response.data)
      }
    } catch (e) {
      store.dispatch('showSnackMessage', {
        color: 'error',
        text: error + ' / ' + e,
      })
    }

    return Promise.reject(error)
  }
)

export default instance

export function processApiError(error) {
  const homeStatuses = [401, 25004, 25002]
  if (error && homeStatuses.includes(error.dataStatus)) {
    router.push('/')
    return
  }
  let errorMessage = error.message || error.error || error.statusText

  let additionalInfo = ''
  if (error) {
    if (typeof error === 'string') {
      additionalInfo = error
    } else if (error.msg) {
      additionalInfo = error.msg
    } else if (error.statusDescription) {
      additionalInfo = error.statusDescription
    }
    if (!errorMessage && additionalInfo) {
      errorMessage = additionalInfo
      additionalInfo = ''
    } else {
      additionalInfo = additionalInfo ? ' (' + additionalInfo + ')' : ''
    }
  }

  store.dispatch('showSnackMessage', {
    color: 'error',
    text: errorMessage + additionalInfo,
  })
}
